type CollectibleCountTextProps = {
  collected: number;
  total: number;
  className?: string;
};

/** Figma `collectible_count_text` (130:21291) — Matias 54, white + stroke #4D3C82. */
export function CollectibleCountText({
  collected,
  total,
  className,
}: CollectibleCountTextProps) {
  return (
    <svg
      className={className}
      width={174}
      height={60}
      viewBox="0 0 174 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="status"
      aria-label={`${collected} из ${total}`}
    >
      <text
        className="collectible-progress__count-text"
        textAnchor="start"
        xmlSpace="preserve"
      >
        <tspan x={0} y={48}>
          {`${collected} из ${total}`}
        </tspan>
      </text>
    </svg>
  );
}
